import { useState, useEffect } from "react";

import { Modal, Button, Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import ValidateLicenceModel from "./ValidateLicenceModel";
import { verifyLicenseDetails } from "@/api/bid";

function CorporateModel({
  show,
  handleClose,
  handleSubmit,
  addLicenseInfo,
  editData,
  formData,
  isEditing,
  // corporateSetTableInfoData,
}) {
  const [corporateInfo, setCorporateInfo] = useState({
    IssueBy: "",
    LicenseNumber: "",
    ExpiryDate: "",
    AddressLine1: "",
    AddressLine2: "",
    city: "",
    zipcode: "",
    Status: "",
    state: "",
    agentLicenseState: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const corporateFormHandler = (e) => {
    const { name, value } = e.target;
    setCorporateInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

 
  useEffect(() => {
    if (editData) {
      const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        const [month, day, year] = dateString.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      };
      setCorporateInfo({
        IssueBy: editData.affiliatedCompany || "",
        state: editData.state || "",
        LicenseNumber: editData.licenceNumber || "",
        ExpiryDate: formatDateForInput(editData.licenceExpiryDate) || "",
        AddressLine1: editData.address1 || "",
        AddressLine2: editData.address2 || "",
        city: editData.city || "",
        zipcode: editData.zipcode || "",
        Status: editData.status || "",
        agentLicenseState: editData.agentLicenseState || "",
      });
    } else {
      // Reset form when not editing
      setCorporateInfo({
        IssueBy: "",
        state: "",
        LicenseNumber: "",
        ExpiryDate: "",
        AddressLine1: "",
        AddressLine2: "",
        city: "",
        zipcode: "",
        Status: "",
        agentLicenseState: "",
      });
    }
  }, [editData]);
  useEffect(()=>{  setCorporateInfo({
          IssueBy: "",
          LicenseNumber: "",
          state: "",
          ExpiryDate: "",
          AddressLine1: "",
          AddressLine2: "",
          city: "",
          zipcode: "",
          Status: "",
          agentLicenseState: "",
        });},[show])
  const handleFormSubmit = async () => {
    // Pass the license info to parent component
    const { isValid, newErrors } = ValidateLicenceModel(corporateInfo);
    if (!isValid) {
      setFormErrors(newErrors);
      return;
    } else {
      setFormErrors({});
      const licNo = corporateInfo.LicenseNumber;
      const stateid = corporateInfo.state;
      const formatDateForApi = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${month}/${day}/${year}`;
      };

      const payload = {
        affiliatedCompany: editData
          ? editData.affiliatedCompany
          : corporateInfo.IssueBy,
        agentLicenseState: editData
          ? editData.agentLicenseState
          : corporateInfo.agentLicenseState,
        cityFromDropDown: false,
        licenceExpiryDate: editData
          ? editData.licenceExpiryDate
          : formatDateForApi(corporateInfo.ExpiryDate),
        licenceNumber: editData
          ? editData.licenceNumber
          : corporateInfo.LicenseNumber,
        primaryAgentLicenceId: editData ? editData.licenceId : undefined,
        stateId: editData ? editData.state : corporateInfo.state,
        agentLicenseAddress1:editData?editData?.address1:corporateInfo.AddressLine1,
        agentLicenseAddress2:editData?editData?.address2:corporateInfo.AddressLine2,
        agentLicenseCity:editData?editData?.city:corporateInfo.city,
        agentLicenseZip:editData?editData?.zip:corporateInfo.zipcode,
      };

      const payloadEdit = {
        affiliatedCompany: corporateInfo.IssueBy,
        agentLicenseState: corporateInfo.agentLicenseState,
        cityFromDropDown: false,
        licenceExpiryDate: formatDateForApi(corporateInfo.ExpiryDate),
        licenceNumber: corporateInfo.LicenseNumber,
        primaryAgentLicenceId: editData ? editData.licenceId : undefined,
        stateId: editData ? editData.state : corporateInfo.state,
         agentLicenseAddress1:corporateInfo.AddressLine1,
        agentLicenseAddress2:corporateInfo.AddressLine2,
        agentLicenseCity:corporateInfo.city,
        agentLicenseZip:corporateInfo.zipcode,
      };

      let response = await verifyLicenseDetails(licNo, stateid);
      if (response?.data?.errorMessage === null) {
        handleSubmit(isEditing ? payloadEdit : payload);
        // setCorporateInfo({
        //   IssueBy: "",
        //   LicenseNumber: "",
        //   state: "",
        //   ExpiryDate: "",
        //   AddressLine1: "",
        //   AddressLine2: "",
        //   city: "",
        //   zipcode: "",
        //   Status: "",
        //   agentLicenseState: "",
        // });
      } else {
      }

    }

   
  };
  const closeModal = () =>{
    setFormErrors({});
    handleClose();
    setShowStateLicenseError("");
     setLicenceInfo({
          IssueBy: "",
          LicenseNumber: "",
          state: "",
          ExpiryDate: "",
          AddressLine1: "",
          AddressLine2: "",
          city: "",
          zipcode: "",
          Status: "",
          agentLicenseState: "",
        });
  }
   const handleBlur = (e) => {
      const { name, value } = e.target;
      const validationResult = ValidateLicenceModel(corporateInfo);
      setFormErrors((prev) => ({
        ...prev,
        [name]: validationResult.newErrors[name],
      }));
    };
  return (
    <>
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add License</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              {addLicenseInfo?.map((field, index) => (
                <>
                  <Form.Group
                    as={Col}
                    md="6"
                    key={index}
                    controlId={`lform${field.label.replace(/\s+/g, "")}`}
                    className="mb-3"
                  >
                    <Form.Label className="form-label pp-form-label fs-12">
                      {field.label}
                    </Form.Label>
                    {field?.required && <span className="text-danger">*</span>}
                    {field.type === "select" ? (
                      <>
                        <Form.Select
                          as="select"
                          name={field.formValueLabel}
                          className={`${formErrors[field.formValueLabel]?"error-border":""} form-control pp-input-field pp-form-label form-field-style`}
                          onChange={corporateFormHandler}
                          value={corporateInfo[field?.formValueLabel]}
                          onBlur={handleBlur}
                        >
                          <option value="">Select</option>
                          {field?.options?.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    ) :field.type === "date" ? (
                       <>
                        <Form.Control
                          type="date"
                          // placeholder={field.placeholder}
                          className={`${formErrors[field.formValueLabel]?"error-border":""} form-control pp-input-field pp-form-label form-field-style`}
                          value={corporateInfo[field?.formValueLabel] ? new Date(corporateInfo[field.formValueLabel])
                              .toISOString() 
                              .split("T")[0]
                          : ""}
                          name={field.formValueLabel} // Add this line
                          onChange={corporateFormHandler}
                          onBlur={handleBlur}
                        />
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    ): (
                      <>
                        <Form.Control
                          type={field.type}
                          // placeholder={field.placeholder}
                          className={`${formErrors[field.formValueLabel]?"error-border":""} form-control pp-input-field pp-form-label form-field-style`}
                          value={corporateInfo[field?.formValueLabel]}
                          name={field.formValueLabel} // Add this line
                          onChange={corporateFormHandler}
                            onBlur={handleBlur}
                        />
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    )}
                  </Form.Group>
                </>
              ))}

              <div className="bid-license-modal-btn-container">
                <Button
                  className="bid-license-modal-h-button-1"
                  variant="primary"
                  onClick={handleFormSubmit}
                >
                  {editData ? "Update" : "Add License"}
                </Button>
                <Button
                  className="bid-license-modal-h-button-2"
                  variant="secondary"
                  onClick={closeModal}
                >
                  Cancel
                </Button>
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CorporateModel;
